import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {Utils} from '../../../../../../common/services/Utils';
import {ProfessionTypeService} from '../../../../../../common_services/profession-type.service';
import {DictionaryService} from '../../../../services/dictionary.service';

@Component({
  selector: 'app-admission-edit-modal',
  templateUrl: './admission-edit-modal.component.html',
  styleUrls: ['./admission-edit-modal.component.scss']
})
export class AdmissionEditModalComponent implements OnInit {

  dicDto = null;
  yearList = [];
  centerProfessionList = [];
  classifierTypes = [];
  subjectList = [];
  educatedList = [];
  selectedSubjectList = [];
  oldSelectedSubjectList = [];

  constructor(public _dialogRef: MatDialogRef<AdmissionEditModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private _utils: Utils,
              private _dialog: MatDialog,
              private _professionTypeService: ProfessionTypeService,
              private _dictionaryService: DictionaryService) {
    this.dicDto = Object.assign({}, data.dto);
    this.oldSelectedSubjectList = Object.assign([], data.dto.subjectList);
    /*this.centerProfessionList =  Object.assign([], data.centerProfessionList);
    if (this.centerProfessionList.length && this.centerProfessionList[0].code === '') {
      this.centerProfessionList.splice(0, 1);
    }*/

    this.yearList = Object.assign([], data.yearList);
    if (this.yearList.length && this.yearList[0].id == -1) {
      this.yearList.splice(0, 1);
    }

    if (this.dicDto && this.dicDto.id) {
      this.dicDto.professionCode = this.dicDto.profession.code;
      this.dicDto.educatedId = this.dicDto.educated.id;
      this.changeEducated();
      if (this.dicDto.subjectList) {
        this.selectedSubjectList = this.dicDto.subjectList.map(e => e.subject.id);
      }
    } else {
      this.dicDto = [];
      this.dicDto.entPassYear =  new Date().getFullYear();
      this.dicDto.classifierType =  1;
    }
    this.changeClassifierType();

  }

  ngOnInit() {
    this._dictionaryService.getDicBaseEducationList().subscribe(list => {
        this.educatedList = this._utils.translateList(list, 'name');
      }
    );

    this._dictionaryService.getDicClassifierTypesList().subscribe(list => {
        this.classifierTypes = this._utils.translateList(list, 'name');
      }
    );
  }

  onSubmit() {
    // const subjectTypeId = this.dicDto.educatedId === 1 ? 5 : (this.dicDto.educatedId === 2 ? 6 : 0);
    const subjectTypeId = this.dicDto.educatedId;
    this.dicDto.subjectList  = [];
    this.selectedSubjectList.forEach(e => {
      const subject = this.oldSelectedSubjectList.filter(o => o.subject.id == e);
      if (subject && subject.length) {
        subject[0].typeId = subjectTypeId;
        subject[0].subjectId = subject[0].subject.id;
        this.dicDto.subjectList.push(subject[0]);
      } else {
        this.dicDto.subjectList.push({subjectId: e, typeId: subjectTypeId});
      }
    });

    this._dictionaryService.saveDicAdmission(this.dicDto).subscribe(
      (data) => {
        this._utils.notifySuccess('saved', null);
        this._dialogRef.close(true);
      },
      error => {
        if (error.status == 409) {
          this._utils.notifyError('Запись уже существует', [this.dicDto.nameRu]);
        } else {
          this._utils.notifyError('error_occurred', null);
        }
      }
    );
  }

  changeEducated() {
    this.selectedSubjectList = [];
    if (this.dicDto && this.dicDto.educatedId) {
      // 5 - Профильные предметы для поступления в колледж после 9(10) классов
      // 6 -  Профильные предметы для поступления в колледж после 11(12) классов
      const subjectTypeId = this.dicDto.educatedId === 1 ? 5 : (this.dicDto.educatedId === 2 ? 6 : 0);
      this._dictionaryService.getDicSubjectForAdmissionListByTypeAndYear(this.dicDto.educatedId, this.dicDto.entPassYear).subscribe(list => {
        this.subjectList = list;
      });
    }
  }

  changeClassifierType() {
    if (this.dicDto && this.dicDto.classifierType) {
      this._dictionaryService.getCenterProfessionsByClassifier(this.dicDto.classifierType).subscribe(list => {
        this.centerProfessionList = this._utils.translateList(list, 'name');
        this.centerProfessionList.forEach(cp => {
           cp.name = cp.code  + ' ' + cp.name;
        });
      });
    }
  }

  close(): void {
    this._dialogRef.close(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/dictionary/admission-list/admission-edit-modal/admission-edit-modal.component.ts